export const REPORT_ERROR = "REPORT_ERROR";
export const reportError = (error) => ({
  type: REPORT_ERROR,
  error,
});

export const CLEAR_ERRORS = "CLEAR_ERROR";
export const clearErrors = () => ({
  type: CLEAR_ERRORS,
});

export const REPORT_SUCCESS = "REPORT_SUCCESS";
export const reportSuccess = (successMessage) => ({
  type: REPORT_SUCCESS,
  successMessage,
});

export const CLEAR_SUCCESS = "CLEAR_SUCCESS";
export const clearSuccess = () => ({
  type: CLEAR_SUCCESS,
});
